module.exports = __webpack_public_path__ + "img/bleu-7.b08488fe.png";